import {
  ImportedNgModuleProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import { Store } from 'libs/framework/core/src';
import {
  SOFTLINE_FEATURE_TRANSLATION,
  TranslationStore,
} from 'libs/framework/ui-core/src';
import {
  ApplicationStore,
  SOFTLINE_FEATURE_APPLICATIONS,
} from 'libs/framework/application/src';
import { default as de } from '../i18n/de.json';
import {
  SOFTLINE_PERMISSION_ESL,
} from './esl-link.shared';
import {
  provideSoftAppsModule,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from 'libs/softapps/core/src';
import { eslLinkRoutes } from './esl-link.routes';

export const eslLinkProviders: (Provider | ImportedNgModuleProviders)[] = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'eslLink',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: '#ESL_LINK.TITLE',
      icon: 'fa-regular fa-tags',
      route: '/esl-link/associate',
      permission: SOFTLINE_PERMISSION_ESL,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: 'ESL-Flash',
      icon: 'fa-regular fa-lightbulb-exclamation-on',
      route: '/esl-link/flash',
      permission: SOFTLINE_PERMISSION_ESL,
    });
  }),
];

export function provideEslLinkProviders() {
  return [
    provideSoftAppsModule(
      {
        name: 'esl-link',
        title: '#ESL_LINK.TITLE',
        icon: 'fa-regular fa-tags',
        route: '/esl-link/associate',
        permission: SOFTLINE_PERMISSION_ESL,
      },
      withSoftAppsModuleTranslation({ de }),
      withSoftAppsModuleRoutes({ app: eslLinkRoutes })
    ),
    provideSoftAppsModule({
      name: 'ESL-Flash',
      title: 'ESL-Flash',
      icon: 'fa-regular fa-lightbulb-exclamation-on',
      route: '/esl-link/flash',
      permission: SOFTLINE_PERMISSION_ESL,
    }),
  ];
}
